import { Directive, Input, OnChanges, OnDestroy, SimpleChanges, inject } from '@angular/core';
import { IButton } from '../_shared/models/button/button.model';
import { BackgroundVariant } from '../_shared/models/hero/hero-variant.enum';
import { ButtonType } from '../_shared/types/button/button.type';
import { BreadcrumbService } from '../_shared/services/breadcrumb.service';
import { ImageData } from '../_shared/models/image/image-data.model';

/**
 * Base directive for hero components.
 * Provides common functionality for setting breadcrumb variant based on hero background.
 */
@Directive({
    standalone: true,
})
export abstract class HeroBase implements OnChanges, OnDestroy {
    @Input() title = '';
    @Input() textHtml = '';
    @Input() buttonPrimary?: IButton;
    @Input() buttonSecondary?: IButton;

    @Input() variant: BackgroundVariant = BackgroundVariant.LIGHT;
    imageData?: ImageData;

    get buttonType(): ButtonType {
        return this.variant === BackgroundVariant.LIGHT ? 'primary' : 'secondary';
    }

    protected _breadcrumbService = inject(BreadcrumbService);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['variant']) {
            this._breadcrumbService.setVariant(this.variant);
        }
    }

    ngOnDestroy(): void {
        this._breadcrumbService.reset();
    }
}
